<template>
  <v-card class="vuetify-schedule-card" tile color="error">
    <v-toolbar color="primary" dark>
      <v-toolbar-title>{{ toolbarTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-tabs
      v-model="schedulesValue"
      slider-color="primary"
      centered
    >
      <v-tab v-for="(element, index) in items" :key="index" ripple>
        {{ element.category_name }}
      </v-tab>
      <v-tabs-items v-model="schedulesValue">
        <v-tab-item v-for="(element, index) in items" :key="index" >
          <v-card flat>
            <v-list>
              <template v-for="(item, index) in element.items">
                <v-list-tile
                  avatar
                  ripple
                  @click="onChangeDisponibility(item, element.selected)"
                  :key="item.text"
                >
                  <v-list-tile-avatar>
                    <v-icon color="primary">access_time</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-icon
                      color="grey lighten-1"
                      v-if="element.selected.indexOf(item.value) < 0"
                    >pause_circle_filled</v-icon>
                    <v-icon
                      color="primary"
                      v-else
                    >check_circle</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider v-if="index + 1 < element.items.length" :key="index"></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>

<script>
  'use strict'

  export default {

    name: 'VuetifyScheduleSelector',

    props: {
      schedules: {
        type: Array,
        default: null,
        required: true
      },
      color: {
        type: String,
        default: 'primary',
        required: false
      },
      toolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      value: {
        type: Array,
        default: null
      }
    },

    data: () => ({
      items: [],
      schedulesValue: null
    }),

    mounted () {
      this.schedulesValue = '0'
    },

    watch: {

      schedules: {
        handler: function (newVal, oldVal) {
          this.items = newVal
        },
        deep: true
      },

      items: {
        handler: function (newVal, oldVal) {
          this.$emit('update:value', newVal)
        },
        deep: true
      }
    },

    methods: {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeDisponibility (item, selected) {
        const index = selected.indexOf(item.value)
        if (index > -1) {
          this.$emit('on-delete-schedule', index, item, selected)
        } else {
          this.$emit('on-add-schedule', item, selected)
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onDiscardDeletion (ref) {
        this.showConfirmDialog = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onConfirmDeletion () {
        this.showConfirmDialog = false
        this.deletePhone()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deletePhone () {
        this.items.splice(this.currentIndex, 1)
        this.$emit('on-delete-phone')
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addPhone () {
        this.$refs.aggregator.dialog = false
        let item = {
          type: this.phoneType.text,
          value: this.phoneNumber
        }
        this.items.push(item)
        this.$refs.form.reset()
        this.$emit('on-add-phone')
      }
    }
  }
</script>

<style lang="sass">
.vuetify-schedule-card
  margin-bottom: 20px
  min-height: 298px !important
</style>


// WEBPACK FOOTER //
// src/components/vuetify-schedule-selector.vue